import React from 'react'
import {
  type ISendFromMultiUiProps,
  SendFromMultiUi,
} from 'widgets/SendFromMulti/ui/SendFromMultiUi'
import { SendFromMultiContext } from 'widgets/SendFromMulti/context/context'
import { type SendFromMultiStore } from './store/SendFromMultiStore'

type ISendFromProps = {
  store: SendFromMultiStore
} & ISendFromMultiUiProps

export const SendFromMulti = ({ store, ...props }: ISendFromProps) => {
  return (
    <SendFromMultiContext.Provider value={store}>
      <SendFromMultiUi {...props} />
    </SendFromMultiContext.Provider>
  )
}
